import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 10,
    height: '100%',
  },
  containerHeader: {
    marginTop: 30,
  },
  description: {
    textAlign: 'center',
    fontSize: 14, // Aumentado de 12 para 14
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20, // Ajustado proporcionalmente
    maxWidth: 250,
    alignSelf: 'center',
    color: Colors.GrayPallete.lightgrayThree,
  },
  error: {
    color: 'black',
    fontSize: 18, // Aumentado de 16 para 18
    fontFamily: 'TCCC-UnityText Regular',
  },
  containerFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  orders: {
    fontSize: 18, // Aumentado de 16 para 18
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 21, // Ajustado proporcionalmente
    color: 'black',
    marginBottom: 10,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  filter: {
    marginRight: 10,
    fontSize: 14, // Aumentado de 12 para 14
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 16, // Ajustado proporcionalmente
    color: Colors.RedPallete.red,
  },
  containerFlat: {
    marginTop: 40,
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 15,
  },
  filterText: {
    marginRight: 10,
    fontSize: 14, // Aumentado de 12 para 14
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 16, // Ajustado proporcionalmente
    color: Colors.RedPallete.red,
  },
  buttonFilter: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  products: {
    fontSize: 18, // Aumentado de 16 para 18
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 21, // Ajustado proporcionalmente
    color: 'black',
  },
  containerError: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    text: 'black',
  },
  containerFooter: {
    marginTop: 'auto',
    paddingVertical: 20,
  },
  itemContainer: {
    backgroundColor: Colors.GrayPallete.lightgray,
    padding: 15,
    marginVertical: 8,
    borderRadius: 10,
  },
  itemText: {
    fontSize: 16, // Aumentado de 14 para 16
    fontFamily: 'TCCC-UnityText Regular',
    color: 'black',
    marginBottom: 5,
  },
  subItemContainer: {
    backgroundColor: Colors.GrayPallete.white,
    padding: 10,
    marginVertical: 5,
    borderRadius: 8,
  },
  subItemText: {
    fontSize: 14, // Aumentado de 12 para 14
    fontFamily: 'TCCC-UnityText Regular',
    color: 'black',
  },
  errorText: {
    fontSize: 18, // Aumentado de 16 para 18
    fontFamily: 'TCCC-UnityText Regular',
    color: 'black',
    textAlign: 'center',
  },


  productContainer: {
    marginBottom: 15,
  },
  productName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 5,
  },
  productDetails: {
    paddingVertical: 10,
    paddingHorizontal: 15,
    backgroundColor: '#f9f9f9',
    borderRadius: 8,
    marginTop: 5,
  },
  productText: {
    fontSize: 12,
    color: '#555',
    marginBottom: 5,
  },
  productImage: {
    width: 100,
    height: 100,
    borderRadius: 8,
    marginTop: 10,
  },
});
